(function () {
// Modal para abrir imagens
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


var $1ee69cfd6a47335f$var$ImageModal = /*#__PURE__*/ function() {
    "use strict";
    function ImageModal() {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, ImageModal);
        this.modal = null;
        this.modalImage = null;
        this.init();
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(ImageModal, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                // Criar modal HTML
                var modalHTML = '\n      <div id="imageModal" class="hidden fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4">\n        <div class="relative max-w-4xl max-h-[90vh]">\n          <img id="modalImage" src="" alt="Imagem ampliada" class="max-w-full max-h-[85vh] object-contain rounded-lg">\n          <button id="closeModal" class="absolute top-4 right-4 bg-white rounded-full w-10 h-10 flex items-center justify-center hover:bg-gray-200 transition">\n            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">\n              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>\n            </svg>\n          </button>\n        </div>\n      </div>\n    ';
                document.body.insertAdjacentHTML('beforeend', modalHTML);
                this.modal = document.getElementById('imageModal');
                this.modalImage = document.getElementById('modalImage');
                var closeBtn = document.getElementById('closeModal');
                // Event listeners
                document.querySelectorAll('.gallery-image').forEach(function(img) {
                    img.addEventListener('click', function() {
                        return _this.openModal(img.src);
                    });
                });
                closeBtn.addEventListener('click', function() {
                    return _this.closeModal();
                });
                this.modal.addEventListener('click', function(e) {
                    if (e.target === _this.modal) _this.closeModal();
                });
                // Fechar com ESC
                document.addEventListener('keydown', function(e) {
                    if (e.key === 'Escape') _this.closeModal();
                });
            }
        },
        {
            key: "openModal",
            value: function openModal(imageSrc) {
                this.modalImage.src = imageSrc;
                this.modal.classList.remove('hidden');
                document.body.style.overflow = 'hidden';
            }
        },
        {
            key: "closeModal",
            value: function closeModal() {
                this.modal.classList.add('hidden');
                document.body.style.overflow = 'auto';
            }
        }
    ]);
    return ImageModal;
}();
// Inicializar quando o DOM estiver pronto
document.addEventListener('DOMContentLoaded', function() {
    new $1ee69cfd6a47335f$var$ImageModal();
    // Smooth scroll para links internos
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            var target = document.querySelector(this.getAttribute('href'));
            if (target) target.scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
});

})();
//# sourceMappingURL=amg-guincho.602bfac5.js.map
